var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-campaign-facebook';
                    var viewUrl = 'gfx/sprite.svg#view-icon-campaign-facebook';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 15',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };